export default __webpack_public_path__ + "static/media/about.d76fd809.png";